/**
 * Generates loading placeholder configurations for the tab menu based on container width.
 *
 * @param containerWidth - The width of the container element
 * @param wrapperWidth - The width of the wrapper element (fallback)
 * @param scrollable - Whether scroll arrows are enabled (affects available space)
 * @returns Array of placeholder objects with width and id properties
 */
export const generateLoadingPlaceholders = (
  containerWidth: number | undefined,
  wrapperWidth: number,
  scrollable: boolean,
): Array<{ width: string; id: number }> => {
  const actualContainerWidth = containerWidth || wrapperWidth || 400
  const arrowSpace = scrollable ? 80 : 0
  const availableWidth = actualContainerWidth - arrowSpace - 32

  const tabWidths = [75, 95, 85, 110, 90, 120, 80, 105, 85, 115]

  let placeholders: Array<{ width: string; id: number }> = []
  let usedWidth = 0
  let tabIndex = 0

  while (placeholders.length < 8 && tabIndex < tabWidths.length) {
    const tabWidth = tabWidths[tabIndex] || 90
    const tabMargin = 8
    const totalTabWidth = tabWidth + tabMargin

    if (
      placeholders.length >= 2 &&
      usedWidth + totalTabWidth > availableWidth
    ) {
      break
    }

    placeholders.push({
      width: `${tabWidth}px`,
      id: tabIndex,
    })

    usedWidth += totalTabWidth
    tabIndex++
  }

  if (placeholders.length < 2) {
    placeholders = [
      { width: '85px', id: 0 },
      { width: '95px', id: 1 },
    ]
  }

  return placeholders
}
